import { useState, useEffect } from "react";
import { Container, Row, Col, Button, Card, Spinner, Alert } from "react-bootstrap";
import axios from "axios";
import { FaImage } from "react-icons/fa";
import "./ShopByCategory.css";
import "./Sale.css";

const API_URL = "https://madhusewingmachines.com/api/sales";

const Sales = () => {
    const [bannerData, setBannerData] = useState({
        image: null,
        title: "🔥 Exclusive Sales 🔥",
        description: "Grab the best deals before they're gone!",
        buttonText: "Shop Now",
        buttonLink: "/products",
    });

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchBanner();
    }, []);

    const fetchBanner = async () => {
        try {
            const response = await axios.get(API_URL);

            if (response.data.success) {
                // Make sure the image URL is complete
                const imageUrl = response.data.imageUrl;
                const fullImageUrl = imageUrl.startsWith('http')
                    ? imageUrl
                    : `https://madhusewingmachines.com${imageUrl}`;

                setBannerData({
                    image: fullImageUrl,
                    title: response.data.title || "🔥 Exclusive Sales 🔥",
                    description: response.data.description || "Grab the best deals before they're gone!",
                    buttonText: response.data.buttonText || "Shop Now",
                    buttonLink: response.data.buttonLink || "/products",
                });
            }
        } catch (err) {
            console.error("Banner fetch error:", err);
            if (err.response?.status === 404) {
                // No banner found - use default without image
                setBannerData({
                    image: null,
                    title: "🔥 Exclusive Sales 🔥",
                    description: "Grab the best deals before they're gone!",
                    buttonText: "Shop Now",
                    buttonLink: "/products",
                });
            } else {
                setError("Failed to load sales banner. Please try again later.");
            }
        } finally {
            setLoading(false);
        }
    };

    // Add this for debugging
    console.log("Banner data:", bannerData);

    if (loading) {
        return (
            <Container
                fluid
                className="py-5 d-flex justify-content-center align-items-center"
                style={{ backgroundColor: "#EFFBFF", minHeight: "300px" }}
            >
                <Spinner animation="border" role="status" variant="primary">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </Container>
        );
    }

    if (error) {
        return (
            <Container fluid className="py-4 px-3 px-md-5" style={{ backgroundColor: "#EFFBFF" }}>
                <Alert variant="warning" className="text-center">
                    {error}
                </Alert>
            </Container>
        );
    }

    return (
        <Container
            fluid
            className="py-5 px-3 px-md-5 text-center"
            style={{ backgroundColor: "#EFFBFF" }}
        >
            <h2 className="category-heading">{bannerData.title}</h2>
            <p className="text-muted mb-4" style={{ fontSize: "1.25rem" }}>
                {bannerData.description}
            </p>

            {bannerData.image ? (
                <img
                    src={bannerData.image}
                    alt="Sales Banner"
                    className="sale-banner-img"
                    onError={(e) => {
                        console.error("Image failed to load. URL:", e.target.src);
                        e.target.style.display = 'none';
                        e.target.onerror = null;
                    }}
                />
            ) : (
                <div className="bg-light py-5 px-4 rounded">
                    <FaImage size={40} className="text-secondary mb-3" />
                    <p className="text-muted">No banner image available</p>
                </div>
            )}

            <div className="mt-4">
                {/* <Button
                    href={bannerData.buttonLink}
                    variant="danger"
                    size="lg"
                    className="rounded-pill px-4 py-2 fw-bold"
                >
                    {bannerData.buttonText}
                </Button> */}
            </div>
        </Container>
    );
}; 

export default Sales;